import React from "react"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { getFieldError } from "../../CommonHelper"
import { IB64File } from "../../../../types/IB64File"

export const CommonFileInput: React.FC<{
  label: string
  placeholder: string
  name: string
  errorModel: IErrorModel | undefined
  _callback: (file: IB64File) => void
  _callbackMultiple?: (files: IB64File[]) => void
  multiple?: boolean
  clazzName?: string
  noFieldset?: boolean
  justButton?: boolean
  zipArchive?: boolean
  onlyZipArchive?: boolean
}> = ({
  label,
  placeholder,
  name,
  errorModel,
  _callback,
  _callbackMultiple,
  multiple,
  clazzName,
  noFieldset,
  justButton,
  zipArchive,
  onlyZipArchive
}) => {
  function blobToBase64(blob: Blob) {
    return new Promise<string | ArrayBuffer | null>((resolve, _) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(blob)
    })
  }

  const selectFiles = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files !== null) {
      const items: IB64File[] = []
      for (const [, file] of Array.from(event.target.files).entries()) {
        blobToBase64(file).then(result => {
          if (result) {
            items.push({ b64: result.toString().split(",")[1], name: file.name })
          }
        })
      }
      if (_callbackMultiple) {
        setTimeout(() => _callbackMultiple(items), 100)
      }
    }
  }

  const selectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files !== null) {
      for (const [, file] of Array.from(event.target.files).entries()) {
        blobToBase64(file).then(result => {
          if (result) {
            _callback({ b64: result.toString().split(",")[1], name: file.name }) //items.push({b64: result.toString().split(',')[1], name: file.name});
          }
        })
      }
    }
  }

  if (zipArchive) {
    return (
      <fieldset className={clazzName ? clazzName : ""}>
        <legend>{label}</legend>
        <label className="button-file">
          <input
            type="file"
            accept={onlyZipArchive ? ".zip" : ".zip,.rar,.7zip"}
            className="hidden-object"
            placeholder={placeholder}
            onChange={selectFile}
          />
          {placeholder}
        </label>
        {getFieldError(errorModel, name) ? <p className="error-form">{getFieldError(errorModel, name)}</p> : <></>}
      </fieldset>
    )
  } else if (noFieldset) {
    return (
      <label className="file-chat-btn">
        <input
          type="file"
          className="hidden-object"
          accept=".doc, .docx, .pdf, .jpg, .jpeg, .xls, .xlsx, .png"
          multiple={multiple}
          placeholder={placeholder}
          onChange={multiple ? selectFiles : selectFile}
        />
      </label>
    )
  } else if (justButton) {
    return (
      <label className="button-file">
        <input
          type="file"
          multiple={multiple}
          className="hidden-object"
          accept=".doc, .docx, .pdf, .jpg, .jpeg, .xls, .xlsx, .png"
          placeholder={placeholder}
          onChange={multiple ? selectFiles : selectFile}
        />
        {placeholder}
      </label>
    )
  } else {
    return (
      <fieldset className={clazzName ? clazzName : ""}>
        <legend>{label}</legend>
        <label className="button-file">
          <input
            type="file"
            multiple={multiple}
            accept=".doc, .docx, .pdf, .jpg, .jpeg, .xls, .xlsx, .svg, .png"
            className="hidden-object"
            placeholder={placeholder}
            onChange={multiple ? selectFiles : selectFile}
          />
          {placeholder}
        </label>
        {getFieldError(errorModel, name) ? <p className="error-form">{getFieldError(errorModel, name)}</p> : <></>}
      </fieldset>
    )
  }
}
